import { action } from 'typesafe-actions';
import { ResponseError } from '../../../services/api';
import { ReportsTypes } from './types';

export const requestReports = () => action(ReportsTypes.REPORTS_REQUEST);
export const successReports = (data: any[]) => action(ReportsTypes.REPORTS_SUCCESS, { data });
export const failureReports = (error: ResponseError) =>
  action(ReportsTypes.REPORTS_FAILURE, { error });
